import React, { Component } from 'react';
import Beep from '../../../../../../../../static/Sound/beep-07.mp3';

class BeepComponent extends Component {
    constructor(props) {
      super(props);
      this.setAudioRef = this.setAudioRef.bind(this);
    }
    setAudioRef(element) {
      this.audioRef = element;
    }
  
    componentDidUpdate(prevProps) {
      if (prevProps.condition !== this.props.condition && this.props.condition) {
        // Delay the beep sound by 1 second
        // setTimeout(() => {
          this.playBeep();
        // }, 1000);
      }
    }
  
    playBeep() {
      if (this.audioRef) {
        this.audioRef.play();
      }
    }
  
    render() {
      return (
        <div>
          {/* <p>Condition: {this.props.condition ? 'True' : 'False'}</p> */}
          {/* Add the audio element for the beep sound */}
          <audio ref={this.setAudioRef} src={Beep} preload="auto" />
        </div>
      );
    }
  }

  export default BeepComponent;


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordInterval/BeepComponent.js